import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import {ModalService} from "../../../shared/services/modal.service";
import {AuthService} from "../../../shared/services/auth.service";
import {ParamService} from "../../../shared/services/param.service";
import {TermsContentComponent} from "../../../shared/components/terms-content/terms-content.component";
import {properties} from '../../../../environments/properties';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

    properties = properties;

    @Input() userSubscriptionDetails: any;
    @Input() userInfo: any;
    @Input() currentEnvironment;
    banner;
    displayAcmeTermText: boolean = false;

    constructor(private router: Router,
                public subscriptionService: SubscriptionService,
                private modalService: ModalService,
                public authService: AuthService,
                private activeRoute: ActivatedRoute,
                private paramService: ParamService
    ) {
      this.banner = this.paramService.banner;
    }

    ngOnInit(): void {
        this.displayAcmeTermsText()
    }

    displayAcmeTermsText() {
        if (this.banner === 'acmemarkets') {
            this.displayAcmeTermText = true;
        }
    }

    openTerms(userSubscriptionDetails, userInfo) {
        this.activeRoute.data.subscribe(data => {
                let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject)
                if (isSessionValid) {
                    const sessionData = {...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN']};
                    if (sessionData) {
                        this.userInfo = sessionData;
                        this.subscriptionService.getTerms(this.userInfo, this.currentEnvironment).subscribe((data) => {
                            if (data && data.content) {
                                this.modalService.openModalWithComponent(TermsContentComponent, {
                                    initialState: {
                                        userSubscriptionDetails: userSubscriptionDetails,
                                        userInfo: userInfo,
                                        content: data.content
                                    },
                                    class: 'slot-picker-modal',
                                    backdrop: 'static',
                                    ariaDescribedby: 'slot-msg',
                                    ariaLabelledBy: "dialoghead-slot-details",
                                });
                            }
                        });
                    }
                } else {
                    this.authService.redirectToSSO(data.tokenObject)
                }
            },
            (err => {
                this.authService.redirectToSSO({});
            }));
    }

}
